<template>

    <div class="events-page">
        <Header></Header>
        <section class="events-section">
            <div class="container">
                <div class="row row-1">
                    <div class="col-md-4">
                        <h2>Events</h2>
                    </div>
                    <div class="col-md-8">
                        <ul class="list-inline">
                            <li>
                                <router-link to="/events/all">All</router-link>
                            </li>
                            <li>
                                <router-link to="/events/upcoming">Upcoming</router-link>
                            </li>
                            <li>
                                <router-link to="/events/past">Past</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="!loading" class="row row-2" v-for="(list) in lists" v-bind:key="list.id">
                    <div class="col-md-6">
                        <div class="event-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.images[0].bgImageFile})` }"></div>
                    </div>
                    <div class="col-md-1">
                        <div class="event-date">
                            <div>
                                <h4>{{list.date | formatEventDate}}</h4>
                                <p>{{list.date | formatEventMonth}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <h3>{{list.title}}</h3>
                        <h4><span>{{list.street}}</span> <span class="bullet"></span> <span>{{list.location}}</span></h4>
                        <p>{{list.message}}</p>

                        <a href="#" v-if="list.upcoming">Click here to RSVP</a>
                    </div>
                </div>
                <Loader v-if="loading" />
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import Loader from './include/Loader'
    import axios from 'axios'
    import $ from "jquery"
    import moment from 'moment'
    import router from '../router'
    import backgroundUrl from '@/assets/img/press/image1.jpg'

    export default {
        name: 'Events',
        components: {
            'Header': Header,
            'Footer': Footer,
            'Loader': Loader
        },
        mounted () {
            axios
                .get('/events', {
                    params: {
                        eventId: this.routeId
                    }
                })
                .then(response => {
                    this.loading = false
                    let data = []
                    $.each(response.data, function (key, value) {
                        var x = moment(String(value.date)).format('YYMMDD')
                        var y = moment(String(new Date())).format('YYMMDD')
                        if(x > y){
                            value.upcoming = true
                            data.push(value)
                        } else {
                            value.upcoming = false
                            data.push(value)
                        }
                    })
                    this.lists = data
                })
                .catch(error => console.log(error))
        },
        data() {
            return {
                backgroundUrl: backgroundUrl,
                lists: '',
                loading: true,
                imageUrl: process.env.imageUrl,
                routeId: router.history.current.params.id,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Events.vue